import React from 'react';
import { artistInfo } from '../data/mockData';

const About = () => {
  return (
    <div className="min-h-screen bg-white pt-14" data-testid="about-page">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start">
          {/* Artist Photo */}
          <div className="w-3/5 mx-auto md:mx-0 md:w-2/5 flex-shrink-0">
            <img
              src={artistInfo.photo}
              alt={artistInfo.fullName}
              className="w-full object-contain shadow-xl rounded"
              data-testid="about-artist-photo"
            />
          </div>

          {/* Bio + Exhibitions */}
          <div className="md:w-3/5">
            <h1 className="text-2xl md:text-4xl font-signature text-gray-900 mb-1" data-testid="about-title">
              Nikhita Kapur
            </h1>
            <p className="text-base md:text-lg font-signature text-teal-600 mb-3 md:mb-4">
              painting as niki
            </p>
            <div className="w-12 md:w-16 h-0.5 bg-teal-600 mb-4 md:mb-6" />
            <div className="space-y-4 mb-10" data-testid="about-bio">
              {artistInfo.bio.split('\n\n').map((para, i) => (
                <p key={`bio-${i}`} className="text-sm md:text-base font-signature text-gray-700 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>

          </div>
        </div>

        {/* Second section: Awards/Education left + Studio photo right */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-start mt-16 md:mt-20">
          <div className="md:w-3/5">
            {/* Awards & Recognition */}
            <section className="mb-10" data-testid="awards-section">
              <h2 className="text-base md:text-lg font-signature text-gray-900 mb-4 tracking-wide uppercase">
                Awards & Recognition
              </h2>
              <div className="space-y-3">
                <div className="flex gap-4">
                  <span className="text-xs font-signature text-gray-400 w-16 flex-shrink-0">2026</span>
                  <p className="text-sm font-signature text-gray-700">
                    Sky and Clouds — Juried Virtual Exhibition, Open Call for Artists (International)
                  </p>
                </div>
                <div className="flex gap-4">
                  <span className="text-xs font-signature text-gray-400 w-16 flex-shrink-0">2025</span>
                  <p className="text-sm font-signature text-gray-700">
                    Memory In Transit — International Art Retreat, Hoi An, Vietnam
                  </p>
                </div>
                <div className="flex gap-4">
                  <span className="text-xs font-signature text-gray-400 w-16 flex-shrink-0">Early</span>
                  <p className="text-sm font-signature text-gray-700">
                    {"President's Award — Shankar Arts International"}
                  </p>
                </div>
                <div className="flex gap-4">
                  <span className="text-xs font-signature text-gray-400 w-16 flex-shrink-0">Early</span>
                  <p className="text-sm font-signature text-gray-700">
                    Exhibition — Tretyakov Art Gallery, Moscow, Russia
                  </p>
                </div>
              </div>
            </section>

            <div className="w-full h-px bg-gray-200 mb-10" />

            {/* Art Education */}
            <section data-testid="education-section">
              <h2 className="text-base md:text-lg font-signature text-gray-900 mb-4 tracking-wide uppercase">
                Art Education
              </h2>
              <div className="space-y-3">
                <div>
                  <p className="text-sm font-signature text-gray-700 font-medium">
                    The Art Students League of New York <span className="text-gray-400">|</span> New York, NY
                  </p>
                  <p className="text-xs font-signature text-gray-500 mt-0.5">
                    Professional Studies in Abstraction (Instructors: Larry Poons, Peter Bonner, Peter Reginato)
                  </p>
                </div>
                <div>
                  <p className="text-sm font-signature text-gray-700 font-medium">
                    Drawing New York <span className="text-gray-400">|</span> New York, NY
                  </p>
                  <p className="text-xs font-signature text-gray-500 mt-0.5">
                    Intensive Study in Figure & Portraiture
                  </p>
                </div>
              </div>
            </section>
          </div>

          {/* Studio photo */}
          <div className="md:w-2/5 flex-shrink-0">
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_aeb4750a-f660-4106-8b4a-114b09057700/artifacts/0m45wy3o_IMG_4184.webp"
              alt="Nikhita Kapur in studio with paintings"
              className="w-full object-contain rounded shadow-lg"
              data-testid="about-studio-photo"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
